import type { FC } from 'react';
import { memo, useCallback } from 'react';

import { addUFOCustomMark } from '@atlaskit/react-ufo/custom-mark';

import { usePerformanceAction } from '../usePerformanceAction.tsx';
import type { Props } from '../Bm3PageSegmentLoadMark.tsx';

const noop = () => {};

/**
 * UFO equivalent of Bm3PageSegmentLoadMark.
 *
 * Instead of calling `metric.mark()` (BM3 API), this component records a UFO
 * custom mark via `addUFOCustomMark` at the configured timing.
 */
const UFOSegmentLoadMarkComponent: FC<Props> = memo(
	({ markName, timing, metric, onComplete = noop, timestamp }) => {
		const handleMark = useCallback(() => {
			if (metric) {
				addUFOCustomMark(markName, timestamp);
				onComplete();
			}
			// Not adding exhaustive dependencies because we want this to fire only once,
			// despite any changes to `timestamp`
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [metric, onComplete]);

		usePerformanceAction(handleMark, timing);
		return null;
	},
);

export { UFOSegmentLoadMarkComponent as UFOSegmentLoadMark };
